import React from 'react';
import api from '../../../ui/api';
import useData from '../../useData';
import Modal from '../../../ui/Modal';
import { Button } from '../../../ui/PageShell';
import { StudentDossierDoc, StudentRecordDoc } from '../../../ui/documents';
import useSchoolYear from '../../useSchoolYear';
import { yearLabel, SCHOOL_INFO } from '../../about';

/**
 * Prints one pupil's dossier (إضبارة طالب) or record (وثيقة طالب).
 *
 * Always read back from the server by id — what is printed is what was
 * saved (registration number, class, family), never the form's copy.
 * `registrarName` covers the moment right after adding, before the
 * pupil's created_by_name could be anything but the current user.
 */
export default function DossierPrint({ studentId, kind = 'dossier', registrarName, onClose }) {
  const year = useSchoolYear();
  const { data, loading, error } = useData(async () => {
    const student = await api.student(studentId);
    // A pupil without a family is valid (family_id nullable), so a failed
    // family lookup must not block the document.
    const family = student?.family_id ? await api.family(student.family_id).catch(() => null) : null;
    return { student, family };
  }, [studentId]);

  const academicYear = year?.title ? yearLabel(year.title) : undefined;

  return (
    <Modal
      open
      size="lg"
      title={kind === 'record' ? 'وثيقة طالب' : 'إضبارة طالب'}
      onClose={onClose}
      footer={<Button variant="secondary" onClick={onClose}>إغلاق</Button>}
    >
      {loading ? <p>جارٍ التحميل...</p>
        : error ? <div className="ui-notice ui-notice-danger"><div className="ui-notice-body">{error}</div></div>
          : kind === 'record'
            ? <StudentRecordDoc student={data.student} family={data.family} academicYear={academicYear} showToolbar />
            : (
              <StudentDossierDoc
                student={data.student}
                family={data.family}
                registrarName={registrarName}
                academicYear={academicYear}
                schoolName={SCHOOL_INFO.name}
                logoUrl={SCHOOL_INFO.logo}
                showToolbar
              />
            )}
    </Modal>
  );
}
